// extracted by mini-css-extract-plugin
export default {"filter":"courses_filter__XTD27","filterPanel":"courses_filterPanel__NubPX","filter__titleWrapper":"courses_filter__titleWrapper__hraMC"};